import React from 'react';
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";

const MainMenu = ({name, labelName, handleMenu, anchorEl, handleClose, menuItems}) => {
    return (
        <div>
            <Box sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}>
                <IconButton
                    aria-label="account of current user"
                    aria-controls={`${name}-menu-appbar`}
                    aria-haspopup="true"
                    onClick={handleMenu}
                    color="inherit"
                    sx={{
                        fontSize: '16px',
                        lineHeight: '18px',
                        minWidth: 'unset',
                        padding: 0,
                        "&:hover": {
                            backgroundColor: "transparent",
                            textDecoration: "underline",
                        },
                    }}
                >
                    <Typography component="div" sx={{
                        flexGrow: 1,
                        fontSize: 'inherit',
                        lineHeight: 'inherit',
                    }}>
                        {labelName}
                    </Typography>
                </IconButton>
                <Menu
                    id={`${name}-menu-appbar`}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    keepMounted
                    MenuListProps={{
                        sx: {
                            minWidth: 'unset',
                        }
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {menuItems.map((menuItem) => (
                        <MenuItem key={menuItem.type} onClick={() => window.location.href = menuItem.hrefs}>
                            {menuItem.name}
                        </MenuItem>
                    ))}
                </Menu>

            </Box>
        </div>
    );
};

export default MainMenu;
